/**
 * Threshold-strategy badge for a vocabulary derivation rule (CZNA-365).
 *
 * There is no "source" concept on derivation rules (no ALEPH_CONVERTED/MANUAL
 * split like validation rules), so this mirrors the STYLE of
 * `RuleSourceBadge` (plain inline-styled pill span, no separate CSS file,
 * `data-testid`, `intl.formatMessage` for the label) instead, applied to the
 * closest legitimate analog: the rule's `thresholdStrategy`.
 */
import React from 'react';
import { useIntl } from 'react-intl';
var STYLES = {
    FREQUENCY: { bg: '#e7f0fb', fg: '#1c4f9c', border: '#b9d3f2' },
    COVERAGE_PERCENTILE: { bg: '#fbf1e6', fg: '#8a5a1c', border: '#f0d9b9' },
    EXPLICIT_LIST: { bg: '#e6f4ea', fg: '#1e7e34', border: '#bfe3c8' },
};
var ThresholdStrategyBadge = function (_a) {
    var _b;
    var strategy = _a.strategy;
    var intl = useIntl();
    var palette = (_b = STYLES[strategy]) !== null && _b !== void 0 ? _b : STYLES.FREQUENCY;
    return (React.createElement("span", { "data-testid": "threshold-strategy-".concat(strategy), style: {
            display: 'inline-block',
            backgroundColor: palette.bg,
            color: palette.fg,
            border: "1px solid ".concat(palette.border),
            borderRadius: '10px',
            padding: '0 8px',
            fontSize: '0.8em',
            fontWeight: 600,
            whiteSpace: 'nowrap',
        } }, intl.formatMessage({ id: "ui-czna-authorities.derivationRules.thresholdStrategy.".concat(strategy) })));
};
export default ThresholdStrategyBadge;
